import { render, staticRenderFns } from "./AppVersion.vue?vue&type=template&id=4695cd60&scoped=true"
import script from "./AppVersion.vue?vue&type=script&lang=js"
export * from "./AppVersion.vue?vue&type=script&lang=js"
import style0 from "./AppVersion.vue?vue&type=style&index=0&id=4695cd60&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4695cd60",
  null
  
)

export default component.exports